<template>
  <v-card class="mt-5" height='100%'>
      <v-container fluid class="pa-5">

        <v-row>
          <v-col cols="12" class="text-right">            

            <v-btn
              color="primary"
              outlined
              @click="listDialog= true"
            >
              See more stocks
            </v-btn>               
          </v-col>                           
        </v-row> 
          <v-dialog v-model="listDialog">
              <v-card class="px-7" style="background: #121212;">
                <v-row>
                  <v-col cols="12">
                    <!-- <p>{{title}}</p> -->
                    <v-card-title>
                      {{title}}
                      <v-spacer></v-spacer>
                      <v-btn color="primary" icon @click="listDialog = false">
                          <v-icon color="white" small>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search by name, country, sector..."
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader> -->
                    <v-data-table
                      :search="search"
                      :headers="headers"
                      :items="items"
                      :mobile-breakpoint="0"
                    >
                      <template v-slot:item="row">
                        <tr>
                          <td>
                            <div class="d-flex">
                              <v-btn
                                class="px-2 mr-2 mt-1"
                                color="primary"
                                min-width="0"
                                icon
                                small
                                :to="'/stocks/analyze/' + row.item.ric"
                              >
                                <v-icon>
                                  mdi-magnify-plus-outline
                                </v-icon>
                              </v-btn>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-alert-circle-outline </v-icon>
                                </template>
                                <span>{{ row.item.des }}</span>
                              </v-tooltip>
                            </div>
                          </td>                                 
                          <td>{{ row.item.name }}</td>
                          <td>{{ row.item.ric }}</td>
                          <td>{{ row.item.ticker }}</td>
                          <td>{{ row.item.country }}</td>
                          <td>{{ row.item.sector }}</td>
                          <td>{{ (row.item.pressure/1000000) | numeral('0,0') }}</td>
                          <td>{{ row.item.days_to_trade }}</td>
                          <td>
                            
                            <star-rating :rounded-corners="false" :padding="1" inactive-color="#13305C"  border-color="#233767" :border-width="3" active-color="#cc1166" :increment="0.01" :star-size="20"  :inline="true" :rating="row.item.rating" :show-rating="false" :read-only="true" ></star-rating>

                          </td>
                          <td>{{ row.item.nb_times_recommended}}
                            <recent-investors-expand :title="'Recent investors of ' + row.item.ric" :stock="row.item.ric" :ptf="ptf" :type="type"></recent-investors-expand>
                        </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-card-actions>    
                  <v-spacer></v-spacer>             
                  <v-btn color="primary" text @click="listDialog = false">Close</v-btn>
                </v-card-actions>
              </v-card>                
          </v-dialog>
      </v-container>
    </v-card>
</template>

<script>
  export default {
    name: 'PortfolioAnalyzeComponentMightExpandList',
    props: ['items','title','ptf','type'],    
    components: {
      RecentInvestorsExpand: () => import('@/views/dashboard/components/portfolio/analyze/RecentInvestorsExpand'),      
    },    
    data() {
      return {
        search:"",
        listDialog: false,
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },          
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'RIC', value: 'ric' },          
          { text: 'Ticker', value: 'ticker' },
          { text: 'Country', value: 'country' },
          { text: 'Sector', value: 'sector' },
          { text: 'Pressure (in millions $)', value: 'pressure' },
          { text: 'Days to Trade', value: 'days_to_trade' },
          {
            sortable: true,
            text: 'Investor Potential Rating',
            value: 'rating',
          },
          { text: '# Recent Investors', value: 'nb_times_recommended' },
        ],
        listLoad: true,
        errorbar: false,        
      }
    },
    // mounted () {
    //   this.getListFromApi()
    // },    
    methods: { 
      goToStock(id) {
        this.$router.push({ name: 'StocksAnalyze', params: { stock: id } });
      },           
    },
  }
</script>